import { Component, Prop, h, State, Host } from '@stencil/core';
import '../header-component/header-component';
import '../loader-component/loader-component'


/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/tiles-component-v2.PNG)

#### Content Type
nypwebc_ct_tiles
*/


@Component({
  tag: 'tiles-component-v2',
  styleUrl: 'tiles-component-v2.css',
  scoped: true

})
export class TilesComponentV2 {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
  *Optional - To show/hide header. default is true
  */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;




  

  /**
*Optional - number of columns?
*/
  @Prop() itemperrow: number = 1


  

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"

  /**
  *Optional -bodycolor text color
  */
  @Prop() sectionbodycolor: string = "white"

  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
 *Optional - To show see all link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link
 */
  @Prop() seeallurl: string = "";

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All";
  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";

  /**
 *optional - style (v1 or v2 or v3)
 */
  @Prop() styleversion: string = "v1";


  @State() items: []
  @State() isLoading: boolean = true;
  @State() gtc: string = "";

  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    const filter = "nypwebc_Active eq 1";
    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Url,nypwebc_ImageUrl&$filter=" + filter + "&$orderby=nypwebc_ItemOrder&", { headers: { "Accept": "application/json; odata=verbose" } })

      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
        this.gtc = "repeat(" + this.itemperrow + ",1fr)";
      });
  }

  getContents = () => {


    const contentsArray = []
    this.items.forEach((item: any) => {
      let wrappercss = "image-first"

      contentsArray.push(


        <div class="grid-item">

          <a href={item.nypwebc_Url} target= "_blank"  data-interception="off">
            <div class={wrappercss}>
              <img src={item.nypwebc_ImageUrl} />
              {this.styleversion === "v1" ? <div ><h3 class="text-center tile-title">{item.Title}</h3> </div> : this.styleversion === "v2" ?

                <div class="bottom-left">
                  <h3 class="text-center tile-title" >{item.Title}</h3>
                </div>
                : this.styleversion === "v3" ? null : null
              }
            </div>
          </a>

          {/* <img src={item.nypwebc_ImageUrl} alt={item.Title} /> */}
        </div>



      )


    });

    return contentsArray
  }

 

  handleTabletChange = (e) => {
    if (e.matches) {
      console.log('Media Query Matched!')
      this.gtc = "repeat(2,1fr)"
    }
    else 
    {
      this.gtc = "repeat(" + this.itemperrow + ",1fr)";
    }
  }

  render() {

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: this.sectionbodycolor,
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        // paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: this.sectionbodycolor,
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        // paddingBottom: "10px"
      }
    }
    // let gtc = "repeat(" +  this.itemperrow+",1fr)" 

    // var x = window.matchMedia("(max-width: 600px)")
    const mediaQuery = window.matchMedia("(max-width: 600px)")
    mediaQuery.addEventListener('change',this.handleTabletChange)
    this.handleTabletChange(mediaQuery)
    // if (x.matches) {
    //   gtc = "repeat(1,1fr)"
    // }




    return (
      this.isLoading ? <loader-component />
        :
        this.header && this.items.length > 0 ?
          <div id={this.componentid}>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0 justify-content-center" style={parentstyle} >
              <div style={styleWithHeader} >
                <div style={{ display: "grid", gridTemplateColumns: this.gtc, gap: "5px", padding: "10px" }}>
             
                  {this.getContents()}
                </div>
              </div>
            </div>
          </div>
          :
          <div class="row gx-0 justify-content-center" style={parentstyle} >
            <div style={style} >
              <div style={{ display: "grid", gridTemplateColumns: this.gtc, gap: "5px", padding: "10px" }}>
            
                {this.getContents()}
              </div>
            </div>
          </div>


    )

  }
}
